import { endPoints, requestType } from "../lib/variable";
import Api from "./index";
const getAllCustomer = () => {
  return Api(endPoints.getAllCustomer, requestType.GET);
};

const userStatusUpdate = (id, data) => {
  return Api(`${endPoints.userStatusUpdate}/${id}`, data, requestType.POST);
};

export { getAllCustomer, userStatusUpdate };
